import { FEATURE_NAME } from './constants';
import { createSlice } from '@reduxjs/toolkit';
import * as T from './types';
import * as actions from './actions';

const initialState: T.WidgetState = {
  data: null,
  error: null,
  loading: false,
  widgets: [],
};

export const widgetsSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(actions.fetchWidgetData.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(actions.fetchWidgetData.rejected, (state, action) => {
      state.data = null;
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(actions.fetchWidgetData.pending, (state) => {
      state.data = null;
      state.loading = true;
      state.error = null;
    });

    // Fetch all widgets
    builder.addCase(actions.fetchWidgets.fulfilled, (state, action) => {
      state.widgets = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(actions.fetchWidgets.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(actions.fetchWidgets.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    // Create widget
    builder.addCase(actions.createWidget.fulfilled, (state, action) => {
      state.widgets.push(action.payload);
      state.loading = false;
      state.error = null;
    });
    builder.addCase(actions.createWidget.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(actions.createWidget.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    // Update widget
    builder.addCase(actions.updateWidget.fulfilled, (state, action) => {
      const index = state.widgets.findIndex((w) => w.id === action.payload.id);
      if (index !== -1) {
        state.widgets[index] = action.payload;
      }
      state.loading = false;
      state.error = null;
    });
    builder.addCase(actions.updateWidget.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(actions.updateWidget.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    // Delete widget
    builder.addCase(actions.deleteWidget.fulfilled, (state, action) => {
      state.widgets = state.widgets.filter((w) => w.id !== action.meta.arg.widgetId);
      state.loading = false;
      state.error = null;
    });
    builder.addCase(actions.deleteWidget.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(actions.deleteWidget.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
  },
});
